import { render } from "./TicketDriverData.vue?vue&type=template&id=17b6f10c&ts=true"
import script from "./TicketDriverData.vue?vue&type=script&lang=ts"
export * from "./TicketDriverData.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__